import React from 'react';
import {
  Button as ShadcnButton,
  ButtonProps as ShadcnButtonProps
} from '../ui/button';
import { cn } from '../../lib/utils';

export interface ButtonProps extends Omit<ShadcnButtonProps, 'asChild'> {
  className?: string;
  icon?: React.ReactNode;
}

export default function Button({
  className,
  icon,
  children,
  ...props
}: Readonly<ButtonProps>) {
  const content = (
    <>
      {icon && <div className='mr-2.5'>{icon}</div>}
      {children}
    </>
  );

  return (
    <ShadcnButton className={cn(className)} {...props}>
      {content}
    </ShadcnButton>
  );
}
